export const STORED_TOKEN_KEY_NAME = 'st_token'
